export const SELECTED_COMPANY_HEADER_NAME = 'x-selected-company';
